
import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

interface GradientBackgroundProps {
  className?: string;
}

const GradientBackground: React.FC<GradientBackgroundProps> = ({ className }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className={cn("fixed inset-0 -z-10 overflow-hidden", className)}>
      <motion.div 
        className={cn(
          "absolute inset-0",
          isDark 
            ? "bg-gradient-radial from-[#171C3C]/70 to-[#0F1225]" 
            : "bg-gradient-radial from-[#E0F0FF]/70 to-[#F5F5F7]"
        )}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      />
      
      <div className="absolute inset-0 overflow-hidden">
        {Array.from({ length: 5 }).map((_, i) => (
          <motion.div
            key={i}
            className={cn(
              "absolute rounded-full blur-3xl",
              isDark ? "bg-purple-900/20" : "bg-blue-100/50"
            )}
            style={{
              width: `${Math.random() * 30 + 10}%`,
              height: `${Math.random() * 30 + 10}%`,
              left: `${Math.random() * 80}%`,
              top: `${Math.random() * 80}%`,
            }}
            animate={{
              x: [0, Math.random() * 50 - 25, 0],
              y: [0, Math.random() * 50 - 25, 0],
              opacity: [0.3, 0.6, 0.3],
            }}
            transition={{
              duration: Math.random() * 20 + 20,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default GradientBackground;
